import React, { FC, memo } from 'react'
import {
  FullscreenControl,
  GeolocationControl,
  Map,
  Placemark,
  YMaps,
  ZoomControl,
} from 'react-yandex-maps'
import { useOnlyClientRendering } from '@ucheba/utils/hooks/useOnlyClientRendering'
import { yaMapApiKey } from '@ucheba/utils/constants/core'

import { IMapProps } from './types'

const MapComponent: FC<IMapProps> = ({
  componentHeight,
  zoomControl,
  fullscreenControl,
  geolocationControl,
  zoom = 10,
  center = [55.751244, 37.618423],
  modules = ['geoObject.addon.balloon', 'geoObject.addon.hint'],
  pins,
}) => {
  const mapState = {
    zoom,
    center,
    modules,
  }

  const isClient = useOnlyClientRendering()
  if (!isClient) {
    return null
  }

  return (
    <>
      <YMaps query={{ apikey: yaMapApiKey }}>
        <Map state={mapState} width='100%' height={componentHeight}>
          {zoomControl && <ZoomControl />}

          {fullscreenControl && <FullscreenControl />}

          {geolocationControl && <GeolocationControl />}

          {pins.map((pin) => {
            const { name, color, address, description, latitude, longitude } = pin

            return (
              <Placemark
                key={longitude + latitude}
                geometry={[longitude, latitude]}
                options={{ iconColor: color, preset: 'islands#circleIcon' }}
                modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
                properties={{
                  hintContent: `
                    <div style="padding: 12px; background: #fff; color: rgba(3, 15, 35, 0.6); font-size: 14px;">
                      <div style="color: #030f23; font-weight: bold; font-size: 16px; margin-bottom: 8px;">${name}</div>
                      <div style="color: #030f23; margin-bottom: 8px;">${address}</div>
                      ${description}
                    </div>
                    `,
                }}
              />
            )
          })}
        </Map>
      </YMaps>
    </>
  )
}

export default memo(MapComponent)
